import React from "react";
import { DigitalProduct } from "../../../Redux/digital-product/types";
import { Product } from "../../../Redux/ecommersProduct/types";
import ProductCard from "../../components/ProductCard";

interface DigitalProductsProps {
  products: DigitalProduct[];
  productType?: "all" | "digital" | "service" | "featured";
  loading?: boolean;
  setSelectedProduct?: (product: Product) => void;
}

export const mapDigitalProductToProduct = (digProd: any): Product => {
  const images = [
    digProd.productImages,
    ...(digProd.galleryImages || []),
  ].filter(Boolean);
  if (images.length === 0) images.push("/assets/img/salarlogo.png");

  const unitPrice = digProd.pricingDetails?.unitPrice ?? 0;
  const finalPrice =
    digProd.pricingDetails?.finalPrice ??
    digProd.pricingDetails?.offerPrice ??
    digProd.pricingDetails?.salePrice ??
    unitPrice;

  return {
    _id: digProd._id || digProd.productID,
    productId: digProd.productID || digProd._id,
    name: digProd.productName || "Digital Product",
    description: digProd.productDescription || "",
    mainImage: images[0],
    brand: { name: digProd.brand || "Salar Store" },
    brandId: digProd.brand || "Salar Store",
    vendors: { marketedBy: digProd.brand || "Salar Store" },
    variations: [
      {
        ssin: digProd.ssin || "DEFAULT-SSIN",
        sku: digProd.sku || "DEFAULT-SKU",
        pricing: {
          unitPrice: unitPrice,
          offerPrice: finalPrice,
          finalPrice: finalPrice,
        },
        media: {
          images: images,
        },
      },
    ],
    reviews: digProd.reviews || {
      averageRating: 0,
      totalReviews: 0,
    },
    condition: "new",
  } as any;
};

const DigitalProducts = ({
  products,
  loading,
  setSelectedProduct,
}: DigitalProductsProps) => {
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <p className="text-muted">No products found</p>
      </div>
    );
  }

  return (
    <div className="row g-2 g-md-4 px-2">
      {products.map((digProd, index) => {
        const mappedProduct = mapDigitalProductToProduct(digProd);
        return (
          <ProductCard
            key={digProd._id || digProd.productID || index}
            product={mappedProduct}
            index={index}
            badgeText={
              digProd.featuredListing?.isFeatured
                ? "Featured Deal"
                : digProd.productType || "Digital"
            }
            setSelectedProduct={setSelectedProduct}
            showColumnWrapper={true}
            className="col-6 col-md-4 col-lg-4 col-xl-3"
            detailRoute="/DigitalProductDetails/:id"
          />
        );
      })}
    </div>
  );
};

export default DigitalProducts;
